export default (label) => {
  return localStorage.getItem("tbt-unit") &&
    localStorage.getItem("tbt-unit") === "imperial"
    ? (label * 0.621371).toFixed(0) + " mi"
    : label + " km";
};



// WEBPACK FOOTER //
// ./scripts/util/chartDistanceLabel.js